import React from 'react';
import proptypes from 'prop-types';
const { shape, node, string, bool } = proptypes;
import { RedirectContext } from './RedirectContext';

export const RedirectProvider = (props) => {

  const { children } = props;

  return (
    <RedirectContext.Provider value={props}>
      {children}
    </RedirectContext.Provider>
  );

};

RedirectProvider.propTypes = {
  children: node.isRequired
};
RedirectProvider.defaultProps = {
};
